module.exports = __webpack_public_path__ + "img/logo3.4e2e8989.png";